var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"direct-flight-filter"},[_c('check-box-input',{attrs:{"isHover":_vm.isHover},model:{value:(_vm.isFilterSelected),callback:function ($$v) {_vm.isFilterSelected=$$v},expression:"isFilterSelected"}},[_c('text-common',{attrs:{"is-hover":_vm.isHover}},[_vm._v(" Прямые перелёты ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }